import FooterBottom from "./footer/FooterBottom";
import FooterMiddle from "./footer/FooterMiddle";
import FooterTop from "./footer/FooterTop";

const Footer = () => {
  return (
    <footer className="flex flex-col gap-8 border-t border-gray-200 bg-white">
      <FooterTop />
      <FooterMiddle />
      <FooterBottom />
    </footer>
  );
};

export default Footer;
